import { formatDollars } from '@open-tender/utils'
import styled from '@emotion/styled'
import { formatColor, formatFontSize } from 'utils/helpers'

const CheckSummaryItemView = styled.span<{ isBold?: boolean }>`
  width: 100%;
  margin: 1rem 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${(props) =>
    formatFontSize(
      props.isBold
        ? props.theme.fonts.serviceFeeCustomFontStyles?.fontSize ??
            props.theme.fonts.sizes.small
        : props.theme.fonts.sizes.small
    )};
  color: ${(props) =>
    formatColor(
      props.isBold
        ? props.theme.fonts.serviceFeeCustomFontStyles?.color ??
            props.theme.colors.secondary
        : props.theme.colors.secondary
    )};
  ${(props) =>
    props.isBold
      ? `font-weight: ${
          props.theme.fonts.serviceFeeCustomFontStyles?.weight ?? '400'
        };`
      : null}
  ${(props) =>
    props.isBold
      ? `font-family: ${
          props.theme.fonts.serviceFeeCustomFontStyles?.family ??
          props.theme.fonts.body.family
        };`
      : null}
    
  ${(props) =>
    props.isBold
      ? `text-transform: ${props.theme.fonts.serviceFeeCustomFontStyles?.textTransform};`
      : null}

  ${(props) =>
    props.isBold
      ? `letter-spacing: ${props.theme.fonts.serviceFeeCustomFontStyles?.letterSpacing};`
      : null}
    
  ${(props) =>
    props.isBold
      ? `font-style: ${props.theme.fonts.serviceFeeCustomFontStyles?.fontStyle};`
      : null}
  
  ${(props) =>
    props.isBold
      ? `-webkit-font-smoothing: ${props.theme.fonts.serviceFeeCustomFontStyles?.fontSmoothing};`
      : null}

  ${(props) =>
    props.isBold
      ? `line-height: ${props.theme.fonts.serviceFeeCustomFontStyles?.lineHeight};`
      : null}
    
  span {
    display: block;
  }
`

const CheckSummaryItem = ({
  label,
  value,
  isBold = false,
  style,
}: {
  label: string
  value: string
  isBold?: boolean
  style?: React.CSSProperties
}) => {
  return (
    <CheckSummaryItemView isBold={isBold} style={style}>
      <span>{label}</span>
      <span>{formatDollars(value)}</span>
    </CheckSummaryItemView>
  )
}

export default CheckSummaryItem
